import type { IconSvgObject } from './types';

const PyramidStructure02Icon: IconSvgObject = [
  ["path", { d: "M20.3005 21C21.063 21 21.5449 20.1809 21.1746 19.5144L12.8742 4.57348C12.4932 3.88767 11.5068 3.88767 11.1258 4.57348L2.82536 19.5144C2.45506 20.1809 2.93703 21 3.69951 21H20.3005Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 15L5 15M16.1818 10L8 10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default PyramidStructure02Icon;
